import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Sheet } from '@mui/joy';
import { Link } from 'react-router-dom';
import CustomEvaluationsManager from '../components/CustomEvaluationsManager';
import { checkAuthentication } from '../utils/LicenseVerification';

const ManageEvaluations = () => {
  const [services, setServices] = useState([]);
  const [authenticated, setAuthenticated] = useState(null);

  // Check authentication and load services
  useEffect(() => {
    const init = async () => {
      const isAuthenticated = await checkAuthentication();
      setAuthenticated(isAuthenticated);

      if (isAuthenticated) {
        loadServices();
      }
    };

    init();
  }, []);

  // Load services for evaluation forms
  const loadServices = async () => {
    try {
      const response = await fetch('/api/services', {
        credentials: 'include'
      });
      
      if (response.ok) {
        const serviceData = await response.json();
        setServices(serviceData);
      } else {
        console.error('Failed to load services:', response.statusText);
      }
    } catch (error) {
      console.error('Error loading services:', error);
    }
  };

  if (authenticated === null) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Typography level="h2">Wird geladen...</Typography>
      </Box>
    );
  }

  if (authenticated === false) {
    return (
      <Sheet sx={{ p: 4, maxWidth: 500, mx: 'auto', my: 4, textAlign: 'center', borderRadius: 'md' }}>
        <Typography level="h2" sx={{ mb: 2 }}>Nicht angemeldet</Typography>
        <Typography sx={{ mb: 3 }}>
          Sie sind nicht angemeldet. Bitte melden Sie sich an, um Ihre benutzerdefinierten Auswertungen zu verwalten.
        </Typography>
        <Button component={Link} to="/" variant="solid" color="primary">
          Zur Anmeldeseite
        </Button>
      </Sheet>
    );
  }

  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto', p: { xs: 2, md: 4 } }}>
      <CustomEvaluationsManager services={services} />
      
      <Button 
        component={Link} 
        to="/"
        variant="outlined"
        sx={{ mt: 4 }}
      >
        Zurück zur Hauptseite
      </Button>
    </Box>
  );
};

export default ManageEvaluations;
